import { useCurrentPlanApi } from "@/react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import type { AiActionsBillingData } from "@circle-react/types/CurrentPlan";

interface UseAiActionsBillingReturn {
  billingDetails?: AiActionsBillingData;
  error?: unknown;
  isLoading: boolean;
}

export const useAiActionsBilling = (): UseAiActionsBillingReturn => {
  const { currentPlan, isCurrentPlanLoading, errorFetchingCurrentPlan } =
    useCurrentPlanApi();

  const billingDetails = currentPlan?.ai_actions_billing;

  return {
    billingDetails,
    isLoading: isCurrentPlanLoading,
    error: errorFetchingCurrentPlan,
  };
};
